import LinkIcon from '@mui/icons-material/Link';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import { darkColors } from '@shape-ds/tokens';
import FormatColorTextOutlined from 'assets/icons/FormatColorTextOutlined.svg?react';
import FormatColorFillOutlined from 'assets/icons/FormatColorFillOutlined.svg?react';
import { renderToString } from 'react-dom/server';
import './TextEditorModal.scss';

export const defaultColors = [darkColors.GRAY_7, darkColors.RED_1];

export const defaultHighlightColors = [darkColors.YELLOW_3, ''];

export const customizeIcons = () => {
  const iconMap = {
    '.ql-link': renderToString(<LinkIcon />),
    '.ql-strike': renderToString(<FormatStrikethroughIcon />),
    '.ql-clean': renderToString(<FormatClearIcon />),
    '.ql-header .ql-picker-label': renderToString(
      <div className="text-heading">
        <FormatSizeIcon />
        <KeyboardArrowDownIcon />
      </div>,
    ),
    '.ql-background .ql-picker-label': renderToString(<FormatColorFillOutlined />),
    '.ql-color .ql-picker-label': renderToString(<FormatColorTextOutlined />),
  };

  for (const [selector, iconHTML] of Object.entries(iconMap)) {
    const buttons = document.querySelectorAll(`${selector}`);
    for (const button of Array.from(buttons)) {
      if (button && !button.classList.contains('mui-customized')) {
        button.innerHTML = iconHTML;
        button.classList.add('mui-customized');
      }
    }
  }
};
